import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PropertyDashboardService {
  receivedDownloadTimelineReportRequest: EventEmitter<any>;

  constructor() { 
    this.receivedDownloadTimelineReportRequest = new EventEmitter<any>();
  }

  raiseEventForTimelineReportDownload(link: string, propertyId: string): void {
    this.receivedDownloadTimelineReportRequest.emit({ link, propertyId });
  }
}
